import { API_DRAFT_TOURS } from '../utils/urls';
import { axios, get, post, put } from './baseAxios';

const url = API_DRAFT_TOURS;

export const getTour = (id) => get(`${url}/${id}`);

export const getTours = (request) => get(url, request);

export const updateTour = (id, request) => put(`${url}/${id}`, request);

export const createTour = (request) => post(url, request);

export const deleteTour = (id) => axios.delete(`${url}/${id}`);

export const makeScenes = (tourId: number, request: any) => put(`${url}/${tourId}/make-scenes`, request);

export const makeTour = (tourId: number) => put(`${url}/${tourId}/make-tour`);

export const updateState = (tourId: number, request: any) => put(`${url}/${tourId}/update-state`, request);
